export default function downloadImageFromBlob(blob, fileName) {
  let fileUrl = URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = fileUrl;
  a.download = fileName;
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(fileUrl), 100);
}
